import {
  usePlaybackMediator,
  useTimelinePlayback,
} from "@/contexts/playback-context";
import { useSelector } from "@legendapp/state/react";

import { NativeDatePicker } from "@/components/native-date-picker";
import { ITimezone } from "react-timezone-select";
import dayjs from "dayjs";
import { useViewSettings } from "@/view-settings";
import { resetGlobalObservables } from "@/virtual-store/state";

export const DateTimeRangePicker = () => {
  const timelinePlayback = useTimelinePlayback();
  const mediator = usePlaybackMediator();
  const viewSettings = useViewSettings();

  const { start, end } = useSelector(() => timelinePlayback.dateRange.get());
  const dateValue = [start ? dayjs(start) : null, end ? dayjs(end) : null] as [
    dayjs.Dayjs,
    dayjs.Dayjs,
  ];

  const onDateChange = (
    [startDate, endDate]: [dayjs.Dayjs | null, dayjs.Dayjs | null],
    timezone: ITimezone
  ) => {
    const isDetectionsMode = viewSettings.viewMode.peek() === "detections";
    resetGlobalObservables();

    mediator.startHistory(
      startDate?.toDate(),
      endDate?.toDate(),
      isDetectionsMode
    );

    if (isDetectionsMode) {
      mediator.startDetections(startDate?.toDate());
    }

    if (typeof timezone === "string") {
      timelinePlayback.dateRange.timezone.set(timezone);
    } else {
      timelinePlayback.dateRange.timezone.set(timezone.value);
    }
  };

  return <NativeDatePicker value={dateValue} onChange={onDateChange} />;
};
